import { useEffect, useState } from "react";
import "./Sidebar.scss";
import Category from "./Category/Category";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { toast } from "react-toastify";
interface SidebarProps {
  onOpenFile: (e: any) => void;
}
const Sidebar: React.FC<SidebarProps> = ({ onOpenFile }) => {
  const [activity, setActivity] = useState<
    "professional-info" | "hobbies" | "personal-info" | "contacts"
  >("personal-info");
  const { width } = useWindowDimensions();

  const categories = [
    {
      id: "personal-info",
      title: "personal-info",
      type: "repo",
      open: true,
      repoList: [
        {
          id: "bio",
          title: "bio",
          folderColor: "#E99287",
          open: true,
          files: [{ id: "personal-info-file", name: "personal-info" }],
        },
        {
          id: "interests",
          open: false,
          title: "interests",
          folderColor: "#43D9AD",
          files: [
            { id: "travel", name: "travel" },
            { id: "mobile-developement", name: "mobile developement" },
            { id: "3d-developement", name: "3d developement" },
          ],
        },
        {
          id: "education",
          title: "education",
          folderColor: "#3A49A4",
          open: false,
          files: [{ id: "high-school", name: "high-school" }],
        },
      ],
    },
    {
      id: "professional-info",
      title: "professional-info",
      type: "repo",
      open: true,
      repoList: [
        {
          id: "experience",
          title: "experience",
          folderColor: "#E99287",
          open: true,
          files: [{ id: "sotunec", name: "Full Stack Developer (Sotunec)" }, { id: "kian", name: "Full Stack Developer (Kian)" }, { id: "calx", name: "Full Stack Developer (Calx)" }],
        },
      ],
    },
    {
      id: "hobbies",
      title: "hobbies",
      type: "text",
      open: false,
      textList: [
        {
          id: "dev",
          icon: (
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.49999 0.5H16.5C16.721 0.5 16.933 0.587797 17.0892 0.744078C17.2455 0.900358 17.3333 1.11232 17.3333 1.33333V14.6667C17.3333 14.8877 17.2455 15.0996 17.0892 15.2559C16.933 15.4122 16.721 15.5 16.5 15.5H1.49999C1.27898 15.5 1.06701 15.4122 0.910734 15.2559C0.754454 15.0996 0.666656 14.8877 0.666656 14.6667V1.33333C0.666656 1.11232 0.754454 0.900358 0.910734 0.744078C1.06701 0.587797 1.27898 0.5 1.49999 0.5V0.5ZM12.72 10.9467L15.6667 8L12.72 5.05333L11.5417 6.23333L13.31 8L11.5417 9.7675L12.72 10.9467V10.9467ZM4.68999 8L6.45832 6.2325L5.27999 5.05333L2.33332 8L5.27999 10.9467L6.45832 9.76667L4.68999 8ZM8.36999 12.1667L11.4033 3.83333H9.62999L6.59666 12.1667H8.36999Z"
                fill="#607B96"
              />
            </svg>
          ),
          label: "Development",
        },
        {
          id: "gym",
          icon: (
            <svg width="20" height="20" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M33 16.5H35C35.552 16.5 36 16.948 36 17.5V27.5C36 28.052 35.552 28.5 35 28.5H33C32.448 28.5 32 28.052 32 27.5V17.5C32 16.948 32.448 16.5 33 16.5Z" stroke="#607B96" stroke-width="2"/>
              <path d="M29 12.5H31C31.552 12.5 32 12.948 32 13.5V31.5C32 32.052 31.552 32.5 31 32.5H29C28.448 32.5 28 32.052 28 31.5V13.5C28 12.948 28.448 12.5 29 12.5Z" stroke="#607B96" stroke-width="2"/>
              <path d="M15 12.5H17C17.552 12.5 18 12.948 18 13.5V31.5C18 32.052 17.552 32.5 17 32.5H15C14.448 32.5 14 32.052 14 31.5V13.5C14 12.948 14.448 12.5 15 12.5Z" stroke="#607B96" stroke-width="2"/>
              <path d="M11 16.5H13C13.552 16.5 14 16.948 14 17.5V27.5C14 28.052 13.552 28.5 13 28.5H11C10.448 28.5 10 28.052 10 27.5V17.5C10 16.948 10.448 16.5 11 16.5Z" stroke="#607B96" stroke-width="2"/>
              <path d="M36 22.5H39" stroke="#607B96" stroke-width="2"/>
              <path d="M18 22.5H28" stroke="#607B96" stroke-width="2"/>
              <path d="M7 22.5H10" stroke="#607B96" stroke-width="2"/>
            </svg>
          ),
          label: "GYM",
        },
      ],
    },
    {
      id: "contacts",
      title: "contacts",
      type: "text",
      open: true,
      textList: [
        {
          id: "email",
          icon: (
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.811096 0.548828H15.4108C15.6259 0.548828 15.8322 0.634283 15.9844 0.786393C16.1365 0.938503 16.2219 1.14481 16.2219 1.35992V14.3375C16.2219 14.5526 16.1365 14.7589 15.9844 14.911C15.8322 15.0631 15.6259 15.1486 15.4108 15.1486H0.811096C0.59598 15.1486 0.389675 15.0631 0.237565 14.911C0.0854545 14.7589 0 14.5526 0 14.3375V1.35992C0 1.14481 0.0854545 0.938503 0.237565 0.786393C0.389675 0.634283 0.59598 0.548828 0.811096 0.548828ZM8.15963 7.59158L2.95888 3.17516L1.90851 4.41127L8.17017 9.728L14.3191 4.40721L13.2582 3.18002L8.16044 7.59158H8.15963Z"
                fill="#607B96"
              />
            </svg>
          ),
          label: "h.rihani@outlook.com",
        },
        {
          id: "phone",
          icon: (
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.221 13.0453V16.2319C16.2211 16.46 16.1347 16.6797 15.9791 16.8466C15.8236 17.0136 15.6105 17.1153 15.3829 17.1312C14.9891 17.1583 14.6674 17.1727 14.4187 17.1727C6.45507 17.1727 0 10.7176 0 2.754C0 2.50527 0.0135175 2.18356 0.0414537 1.78975C0.0574246 1.56215 0.159129 1.34908 0.326046 1.19354C0.492962 1.038 0.712664 0.951557 0.940819 0.95166H4.12735C4.23913 0.951547 4.34696 0.992987 4.4299 1.06793C4.51283 1.14287 4.56495 1.24597 4.57613 1.35719C4.59686 1.56445 4.61578 1.72937 4.63381 1.85463C4.8129 3.10448 5.17992 4.32008 5.72242 5.4602C5.80803 5.64044 5.75215 5.85582 5.58994 5.97117L3.64522 7.36077C4.83427 10.1314 7.04222 12.3393 9.81282 13.5284L11.2006 11.5872C11.2573 11.5079 11.3401 11.4511 11.4345 11.4265C11.5288 11.402 11.6288 11.4113 11.717 11.453C12.857 11.9945 14.0723 12.3606 15.3217 12.5389C15.4469 12.5569 15.6118 12.5767 15.8173 12.5966C15.9284 12.6079 16.0312 12.6601 16.106 12.7431C16.1807 12.826 16.2221 12.9337 16.2219 13.0453H16.221Z"
                fill="#607B96"
              />
            </svg>
          ),
          label: "+216 20979006",
        },
      ],
    },
  ];
  let newwidth: any = width ?? width;
  useEffect(() => {
    console.log(newwidth);
  }, [newwidth]);

  const handleCopyClick = async (text: any) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.info("Text copied to clipboard!");
    } catch (error) {
      toast.error(`Failed to copy text: ${error}`);
    }
  };
  return (
    <div className="sidebar-container">
      <div className="sidebar-container__activity-bar">
        <svg
          className={
            activity === "professional-info" ? "" : "inactive-activity"
          }
          onClick={() => setActivity("professional-info")}
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 0.651855H19C19.2652 0.651855 19.5196 0.757212 19.7071 0.944749C19.8946 1.13229 20 1.38664 20 1.65186V17.6519C20 17.9171 19.8946 18.1714 19.7071 18.359C19.5196 18.5465 19.2652 18.6519 19 18.6519H1C0.734784 18.6519 0.48043 18.5465 0.292893 18.359C0.105357 18.1714 0 17.9171 0 17.6519V1.65186C0 1.38664 0.105357 1.13229 0.292893 0.944749C0.48043 0.757212 0.734784 0.651855 1 0.651855V0.651855ZM10 12.6519V14.6519H16V12.6519H10ZM6.414 9.65186L3.586 12.4799L5 13.8949L9.243 9.65186L5 5.40886L3.586 6.82386L6.414 9.65186Z"
            fill="#607B96"
          />
        </svg>
        <svg
          className={activity === "personal-info" ? "" : "inactive-activity"}
          onClick={() => setActivity("personal-info")}
          width="16"
          height="21"
          viewBox="0 0 16 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 18.6519H15V20.6519H1V18.6519ZM8 16.6519C5.87827 16.6519 3.84344 15.809 2.34315 14.3087C0.842855 12.8084 0 10.7736 0 8.65186C0 6.53012 0.842855 4.49529 2.34315 2.995C3.84344 1.49471 5.87827 0.651855 8 0.651855C10.1217 0.651855 12.1566 1.49471 13.6569 2.995C15.1571 4.49529 16 6.53012 16 8.65186C16 10.7736 15.1571 12.8084 13.6569 14.3087C12.1566 15.809 10.1217 16.6519 8 16.6519V16.6519Z"
            fill="#607B96"
          />
        </svg>
        <svg
          className={activity === "hobbies" ? "" : "inactive-activity"}
          onClick={() => setActivity("hobbies")}
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 0.87793C17.5913 0.87793 19.1174 1.51007 20.2426 2.63529C21.3679 3.76051 22 5.28663 22 6.87793V10.8779C22 12.4692 21.3679 13.9954 20.2426 15.1206C19.1174 16.2458 17.5913 16.8779 16 16.8779H6C4.4087 16.8779 2.88258 16.2458 1.75736 15.1206C0.632141 13.9954 0 12.4692 0 10.8779V6.87793C0 5.28663 0.632141 3.76051 1.75736 2.63529C2.88258 1.51007 4.4087 0.87793 6 0.87793H16ZM9 5.87793H7V7.87793H5V9.87793H6.999L7 11.8779H9L8.999 9.87793H11V7.87793H9V5.87793ZM17 9.87793H15V11.8779H17V9.87793ZM15 5.87793H13V7.87793H15V5.87793Z"
            fill="#607B96"
          />
        </svg>
      </div>
      <div className="sidebar-container__activity-content">
        {categories.map((cat) => (
          <Category
            hidden={
              activity !== cat.id && cat.id !== "contacts" && newwidth > 769
            }
            isInitializedAsOpen={cat.open}
            key={cat.id}
            title={cat.title}
            type={cat.type as any}
            repoList={cat.repoList}
            textList={cat.textList}
            openFile={(file) => {
              if (file.id === "phone" || file.id === "email") {
                handleCopyClick(file.label);
              } else if (
                file.id === "dev" ||
                file.id === "3d-developement" ||
                file.id === "mobile-developement" ||
                file.id === "travel"
              ) {
                return;
              } else {
                onOpenFile(file);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
